import { render, staticRenderFns } from "./changeCurrency.vue?vue&type=template&id=7618d225&"
import script from "./changeCurrency.vue?vue&type=script&lang=js&"
export * from "./changeCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports